import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IBankAccount } from '../../../../shared/model/bank-account.model';
import { BankAccountService } from '../../../../shared/services/bank-account.service';
import { IconService } from '../../../../shared/services/icon.service';
import { MasterDataService } from '../../../../shared/services/master-data.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-export-settings',
  templateUrl: './export-settings.page.html',
  styleUrls: ['./export-settings.page.scss']
})
export class ExportSettingsPage implements OnInit {

  public exportTypes$ = this.masterDataService.getExportTypes();

  public bankAccount!: IBankAccount;

  constructor(
    private bankAccountService: BankAccountService,
    private masterDataService: MasterDataService,
    private route: ActivatedRoute,
    private iconService: IconService,
    private snackBar: MatSnackBar,
  ) {
    this.iconService.loadIcon('change');
  }

  public ngOnInit(): void {
    const bankAccountId = Number(this.route.snapshot.paramMap.get('bankAccountId'));
    if (bankAccountId) {
      this.bankAccountService.get(bankAccountId).subscribe((bankAccount) => {
        this.bankAccount = bankAccount;
      });
    }
    const error = this.route.snapshot.queryParamMap.get('error');
    if (error) {
      this.snackBar.open(`Error connecting to Exact Online: ${error}`, 'Dismiss', {
        duration: 15000,
        panelClass: ['error-snackbar']
      });
    }
  }

  public setExportType(exportTypeCode: string): void {
    this.bankAccount.exportType = exportTypeCode;
  }

}
